import ShortUniqueId from 'short-unique-id'

export default new ShortUniqueId()
